import React from 'react'
import { useTranslation } from 'react-i18next'
import ModalForm from '../common/modal-form'
import Button from '../elements/Button'

const ConfirmDelete = ({ isOpen, handleCancel, handleAgree }) => {
    const { t } = useTranslation()

    return (
        <ModalForm
            onClose={handleCancel}
            isOpen={isOpen}
            centered
            contentClass="text-center"
        >
            <div className="heading-5 mt-2">{t('addressMgr.lbConfirmDelete')}</div>
            <div className="mt-4">
                <Button onClick={handleCancel}>
                    {t('addressMgr.btnCancel')}
                </Button>

                <Button onClick={handleAgree} className="ml-4">
                    {t('addressMgr.btnAgree')}
                </Button>
            </div>
        </ModalForm>
    )
}

export default ConfirmDelete